/** One working campaign brief per community. Saving does not publish ads. */
export type AdCampaignPlan = {
  title: string;
  offer: string;
  objective: string;
  audiencePlan: string;
  adAssignments: string;
  measurement: string;
  openDecisions: string;
  notes: string;
  mediaFolder: string;
  assetIds: string[];
  updatedAt: string;
};

export const campaignPlanFields = [
  ["title", "Plan name"],
  ["offer", "Offer"],
  ["objective", "Campaign objective"],
  ["audiencePlan", "Ad sets and targeting"],
  ["adAssignments", "Ads and audience angles"],
  ["measurement", "Success measures"],
  ["openDecisions", "Decisions before launch"],
  ["notes", "Notes and sources"],
  ["mediaFolder", "Creative folder"],
] as const;

export const parseCampaignPlan = (value: unknown): AdCampaignPlan | null => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const data = value as Record<string, unknown>;
  if (typeof data.title !== "string" || !data.title.trim()) return null;
  const plan = emptyCampaignPlan();
  campaignPlanFields.forEach(([key]) => {
    plan[key] = typeof data[key] === "string" ? data[key] as string : "";
  });
  plan.assetIds = Array.isArray(data.assetIds)
    ? data.assetIds.filter((id): id is string => typeof id === "string") : [];
  plan.updatedAt = typeof data.updatedAt === "string" ? data.updatedAt : "";
  return plan;
};

export const emptyCampaignPlan = (): AdCampaignPlan => ({
  title: "", offer: "", objective: "", audiencePlan: "", adAssignments: "",
  measurement: "", openDecisions: "", notes: "", mediaFolder: "",
  assetIds: [], updatedAt: "",
});

export const validateCampaignPlan = (plan: AdCampaignPlan): void => {
  if (!plan.title.trim() || !plan.offer.trim() || !plan.objective.trim()) {
    throw new Error("Add a plan name, offer and campaign objective before saving.");
  }
  if (campaignPlanFields.some(([key]) => plan[key].length > 20000)
    || plan.title.length > 200 || plan.mediaFolder.length > 200
    || plan.assetIds.length > 100 || plan.assetIds.some(id => id.length > 200)) {
    throw new Error("This plan is too long. Shorten the text or reduce the creative references.");
  }
};
